import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//组件懒加载，下载js时显示spin状态。
const router = new Router({
    mode: 'hash',
    routes: []
})

//模拟一个url跳转，但页面不变。一般用于弹出窗口，以便实现浏览器后退时关闭弹窗的效果。需通过监听路由参数关闭弹窗。
router.addRoutePar = function (added, isReplace) {
    const { path, query } = router.currentRoute
    var query1 = { ...query, ...added }
    if (isReplace) {
        this.replaceQry(query1)
    } else {
        router.push({ path, query: query1 }) //产生一个新的历史，可后history.back到原url
    }
}

router.replaceQry = function (query) {
    const { path } = router.currentRoute
    router.replace({ path, query })
}

//禁用重复警告
'push,replace'.split(',').map(method => router[method] = function () {
    return Router.prototype[method].apply(this, arguments).catch(t => 0)
})


export default router;
